
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questionnaire/[...slug]",
      function () {
        return require("private-next-pages/questionnaire/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questionnaire/[...slug]"])
      });
    }
  